import { reducer as orders, namespace as ordersNamespace } from './orders';
import { reducer as drafts, namespace as draftsNamespace } from './drafts';
import { reducer as draftsDetails, namespace as draftsDetailsNamespace } from './draftDetails';
import { reducer as orderDetails, namespace as orderDetailsNamespace } from './orderDetails';
import { reducer as authorizeOrder, namespace as authorizeOrderNamespace } from './authorizeOrder';
import { reducer as captureOrder, namespace as captureOrderNamespace } from './captureOrder';
import { reducer as refundOrder, namespace as refundOrderNamespace } from './refundOrder';
import { reducer as cancelOrder, namespace as cancelOrderNamespace } from './cancelOrder';

export interface State {
    [ordersNamespace]: orders.State;
    [draftsNamespace]: drafts.State;
    [draftsDetailsNamespace]: draftsDetails.State;
    [orderDetailsNamespace]: orderDetails.State;
    [authorizeOrderNamespace]: authorizeOrder.State;
    [captureOrderNamespace]: captureOrder.State;
    [refundOrderNamespace]: refundOrder.State;
    [cancelOrderNamespace]: cancelOrder.State;
}

export const initialState: State = {
    [ordersNamespace]: orders.initialState,
    [draftsNamespace]: drafts.initialState,
    [draftsDetailsNamespace]: draftsDetails.initialState,
    [orderDetailsNamespace]: orderDetails.initialState,
    [authorizeOrderNamespace]: authorizeOrder.initialState,
    [captureOrderNamespace]: captureOrder.initialState,
    [refundOrderNamespace]: refundOrder.initialState,
    [cancelOrderNamespace]: cancelOrder.initialState,
};

export const reducers = {
    [ordersNamespace]: orders.reducer,
    [draftsNamespace]: drafts.reducer,
    [draftsDetailsNamespace]: draftsDetails.reducer,
    [orderDetailsNamespace]: orderDetails.reducer,
    [authorizeOrderNamespace]: authorizeOrder.reducer,
    [captureOrderNamespace]: captureOrder.reducer,
    [refundOrderNamespace]: refundOrder.reducer,
    [cancelOrderNamespace]: cancelOrder.reducer,
};
